import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D1A8C00E-5FE4-4016-9C38-40CD9804D7C9
 * name nail
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nail.svg
 * tags
 * - Hardware / Tools 
 */
export const NailIcon = createSvgIcon(<><path d="M13.5,5V16L12,22L10.5,16V5H13.5M17,2H7V4H17V2Z" /></>, 'NailIcon');
export default NailIcon